module.exports = __webpack_public_path__ + "img/Ident-Process-10-mobile.3ee695f5.png";